import React, {FC, useMemo} from 'react';

import {Trans} from '../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {FrontClickEvent} from '../../../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {CellsContext} from '../../../../../../libs/shared/core/src/store/panels/cells/context/cellsContext';
import {IconButton} from '../../../../../../libs/shared/ui/src/components/buttons/iconButton';
import {VisualSizesEnum} from '../../../../../../libs/shared/ui/src/styles/commonStyles';
import {useUserTheme} from '../../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {ConversationBaseModel} from '../../../../../models/api/conversationModel';
import {ConversationTicketStatusCoordinator} from '../../../viewer/conversation/actions/ticketStatus/conversationTicketStatusCoordinator';
import {CellHoverIconBase} from './hover/cellHoverIconBase';
import {CellsHoverIconsBase} from './hover/cellHoverIconsBase';

/*
 * Props.
 */

interface CellHoverIconsTicketStatusProps {
  isCompact: boolean | undefined;
  conversation: ConversationBaseModel;
  cellsContext: CellsContext;
  isTicketStatusDropdownOpen: boolean;
  onTicketStatusDropdownToggle: (isOpen: boolean) => void;
}

/*
 * Component.
 */

export const CellHoverIconsTicketStatus: FC<CellHoverIconsTicketStatusProps> = (props) => {
  const conversations = useMemo(() => [props.conversation], [props.conversation]);
  const theme = useUserTheme();
  // Don't trigger a double click on the cell when we double click on a hover icon.
  const onDoubleClick = (event: FrontClickEvent) => {
    event.preventDefault();
  };

  return (
    <CellsHoverIconsBase isCompact={props.isCompact}>
      <ConversationTicketStatusCoordinator
        cellsContext={props.cellsContext}
        conversations={conversations}
        placement="bottom-end"
        renderButton={(buttonProps) => (
          <CellHoverIconBase>
            <IconButton
              iconName="changeStatusSmall"
              // TODO: Standardize icon button colors.
              color={theme.greys.shade80}
              hoverColor={theme.greys.shade80}
              backgroundHoverColor={theme.alphas.gray10}
              backgroundColor={buttonProps.isOpen ? theme.alphas.gray10 : undefined}
              onDoubleClick={onDoubleClick}
              label={<Trans id="cell-hover-icons-ticket-status">Change status</Trans>}
              size={VisualSizesEnum.SMALL}
            />
          </CellHoverIconBase>
        )}
        isTicketStatusDropdownOpen={props.isTicketStatusDropdownOpen}
        onTicketStatusDropdownToggle={props.onTicketStatusDropdownToggle}
      />
    </CellsHoverIconsBase>
  );
};
